import { capitalizeFirstLetter } from '@utils/Util';

const getGroupKey = (item, groupBy) => {
	const productResponse = item?.productResponse || {};
	const locationResponse = item?.sampleInventoryLocationResponse || {};

	const keyMap = {
		COLLECTION: () => productResponse?.collectionId || 'No Collection',

		MARKET_AND_CATEGORY: () => {
			const market = productResponse?.productGroup || 'No Market';
			const category = productResponse?.name || 'No Category';
			return `${market} - ${category}`;
		},

		MARKET_AND_FABRIC: () => {
			const market = productResponse?.productGroup || 'No Market';
			const fabric = productResponse?.mainFabricType || 'No Fabric';
			return `${market} - ${fabric}`;
		},

		LOCATION: () => {
			const building = locationResponse?.buildingTagResponse?.text || 'No Building';
			const floor = locationResponse?.floorTagResponse?.text || 'No Floor';
			const room = locationResponse?.roomOrAreaTagResponse?.text || 'No Room';
			const color = locationResponse?.colorTagResponse?.text || 'No color';
			const locationId = locationResponse?.locationId || 'No Location ID';

			return `${building} > ${floor} > ${room} > ${color} > ${locationId}`;
		},

		SIMILAR_FABRIC: () => {
			const fabricName = productResponse?.mainFabricType || 'No Fabric';
			const mainCategory = productResponse?.construction || 'No Construction';
			const subCategory = replacePercentage(productResponse?.compositionDetails || '');
			const gsm = productResponse?.gsm || '';
			const gsmValue = parseInt(gsm);
			let gsmRange = '';

			if (gsmValue >= 1 && gsmValue <= 180) {
				gsmRange = `Light Weight: 1-180 GSM`;
			} else if (gsmValue >= 181 && gsmValue <= 290) {
				gsmRange = `Mid Weight: 181-290 GSM`;
			} else if (gsmValue > 290) {
				gsmRange = `Heavy Weight: 290+ GSM`;
			}

			return `${capitalizeFirstLetter(fabricName)} - ${capitalizeFirstLetter(
				mainCategory
			)}; Composition: ${subCategory}; ${gsmRange || `GSM: ${gsm}`}`;
		},

		PRICE_RANGE: () => productResponse?.costingReviewAssessmentResponse?.name || 'No price range'
	};

	return keyMap[groupBy] ? keyMap[groupBy]() : null;
};

const replacePercentage = (text) => {
	const result = [];
	const arr = text.split(' ');
	arr.forEach((item) => {
		if (!item.includes('%')) {
			result.push(item);
		}
	});

	return result.join(', ');
};

export const groupBy = (data, selectedGroupBy) => {
	return data.reduce((acc, item) => {
		const key = getGroupKey(item, selectedGroupBy);
		if (key) {
			acc[key] = acc[key] || [];
			acc[key].push(item);
		}
		return acc;
	}, {});
};

export const FAVOURITE_SELECT_VIEW = {
	STYLE: {
		name: 'Style',
		key: 'style'
	},
	FABRIC: {
		name: 'Fabric',
		key: 'fabric'
	}
};
export const SUPPLIER_SELECT_VIEW = {
	QTY_PRICE: {
		name: 'Qty & Price',
		key: 'qt_price'
	},
	MARGIN: {
		name: 'Margin',
		key: 'margin'
	}
};

export const FAVOURITES_SORTING_OPTIONS = [
	{ code: 'NEWEST', title: 'Newest first' },
	{ code: 'OLDEST', title: 'Oldest first' },
	{ code: 'STYLE_NO', title: 'Style Number' },
	{ code: 'COLLECTION', title: 'Collection' },
	{ code: 'MARKET_AND_CATEGORY', title: 'Market & Category' },
	{ code: 'MARKET_AND_FABRIC', title: 'Market & Fabric' },
	{ code: 'LOCATION', title: 'Location' },
	{ code: 'SIMILAR_FABRIC', title: 'Similar Fabric' },
	{ code: 'PRICE_RANGE', title: 'Price Range' }
];

export const FAVOURITES_FOLDER_SORTING_OPTIONS = [
	{ code: 'NEWEST', title: 'Newest first' },
	{ code: 'OLDEST', title: 'Oldest first' }
];

export const INITIAL_FOLDER_STATE = {
	folderName: '',
	brand: {}
};

export const FAVOURITES_DETAILS_TABS = [
	{ code: 'DESIGN', title: 'Design' },
	{ code: 'RANGE_PLAN', title: 'Range Plan' }
];

export const FAVOURITES_DETAILS_VIEW_TYPES = [
	{ code: 'LARGE_VIEW', title: 'Large', icon: '/icons/large-view.svg' },
	{ code: 'NARROW_VIEW', title: 'Narrow', icon: '/icons/narrow-view.svg' },
	{ code: 'IMAGE_VIEW', title: 'Image', icon: '/icons/image-view.svg' },
	{ code: 'LIST_VIEW', title: 'List', icon: '/icons/list-view.svg' }
];

export const FAVOURITES_DETAILS_SIDE_PANEL_TABS = ['STYLE', 'COLLECTION', 'LINKED_COLLECTION'];

export const isMyFavourite = (folderId) => {
	return parseInt(folderId) === -1;
};

export const buildRequestBody = (filterValues, folderId) => {
	const requestBody = {};

	const processFilters = (filters) => {
		Object.entries(filters).forEach(([key, value]) => {
			if (Array.isArray(value)) {
				requestBody[key] = value.map((item) => item?.value).filter(Boolean);
				if (key === 'referenceNumber' || key === 'sampleIdentificationNo') {
					requestBody[key] = requestBody[key].join(',');
				}
			} else if (value !== undefined && value !== null) {
				requestBody[key] = value;
			}
		});
	};

	if (Object.keys(filterValues.DETAILS_PAGE_FILTERS).length > 0) {
		processFilters(filterValues.DETAILS_PAGE_FILTERS);
	} else {
		processFilters(filterValues);
	}
	requestBody.folderId = folderId;
	return requestBody;
};

export const MY_FAVOURITE = 'My Favourite';

export const PRICE_RANGE_STATUS = [
	{
		value: 'IN_RANGE',
		label: 'In range',
		className: 'status green-1'
	},
	{
		value: 'OUT_OF_RANGE',
		label: 'Out of range',
		className: 'status red-2'
	},
	{
		value: 'IN_CONSIDERATION',
		label: 'In consideration',
		className: 'status yellow-1'
	},
	{
		value: 'RECHECK',
		label: 'Recheck',
		className: 'status blue-1'
	}
];

export const getUpdatedProductList = (allFavouritesForProducts, response) => {
	const updatedProductList = allFavouritesForProducts?.data?.filter(
		(product) =>
			parseInt(product?.productResponse?.id) !==
			parseInt(response?.payload?.LikedProductList[0]?.productId)
	);
	return updatedProductList;
};
